import { Button } from 'antd'
import DeleteAutoAssignModalHook from './DeleteAutoAssignModal.hook'
import Modal from '@/components/common/Modal'
import { Content } from './styles'

export default function DeleteAutoAssignModal() {
  const { deleteAutoAssignModal, handleSetDeleteAutoAssignModal, onCancelModal, fullname } =
    DeleteAutoAssignModalHook()

  return (
    <Modal
      open={deleteAutoAssignModal.open}
      closable={false}
      width={350}
      centered
      onCancel={() => onCancelModal()}
      onOk={() => handleSetDeleteAutoAssignModal()}
      footer={[
        <Button onClick={() => onCancelModal()}>ยกเลิก</Button>,
        <Button type="primary" danger onClick={() => handleSetDeleteAutoAssignModal()}>
          ลบ
        </Button>,
      ]}
    >
      <b>คุณต้องการลบผู้ใช้งาน</b>
      <Content>
        คุณแน่ใจหรือไม่ที่จะทำการลบผู้ใช้งาน
        <br />“{fullname}”
      </Content>
    </Modal>
  )
}
